export var list = [
  {
    displayName: 'Associate',
    route: 'master/associate',
  },
  {
    displayName: 'Commodity Type',
    route: 'master/comodityType',
  },
  {
    displayName: 'Commodity Master',
    route: 'master/commuditymaster',
  },

  {
    displayName: 'Quality / Grade',
    route: 'master/qualitygrade',
  },
  {
    displayName: 'Knowledge And Contest',
    route: 'master/knowladgecontest',
  },
  {
    displayName: 'Banners',
    route: 'master/banners',
  },
  {
    displayName: 'Tabs Access',
    route: 'master/tabs',
  },
];